import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import {DataProcessorSupplement} from "slotworks/model/gameplay/supplements/data-processor-supplement";
import {AnticipationResult} from "slotworks/model/gameplay/records/results/anticipation-result";
import RespinRecord from "./respin-record";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";

class SGAnticipationSupplement implements DataProcessorSupplement {

    public process(record: Record) {
        const anticipationResult: AnticipationResult = new AnticipationResult();
        anticipationResult.reelAnticipations = [false, false, false, false, false];

        if (record instanceof SpinRecord && record.grid) {
            if (record.grid[0].find(element => element.indexOf("scatter") !== -1)) {
                anticipationResult.reelAnticipations = [false, true, true, true, false];
            }
        }

        if ((record instanceof RespinRecord || record instanceof FreespinRecord) && record.grid) {
            anticipationResult.reelAnticipations = [true, false, false, false, false];
        }
        record.results.push(anticipationResult);
    }
}

export default new SGAnticipationSupplement();
